export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-aea99675a06997218279.worker.js");
}
